import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectPendingBessResigns } from "../../store/bessResignSlice";

const BessResignBanner = () => {
  const { t } = useTranslation("bessresign");
  const pending = useSelector(selectPendingBessResigns);

  if (pending.length === 0) return null;

  return (
    <div className="mt-12 mb-8 flex items-start gap-3 px-4 py-3 border border-[#FED7AA] rounded-md bg-[#FFEDD5] text-[#9A3412] text-sm">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#C2410C]"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.732 0 2.815-1.874 1.95-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
        />
      </svg>
      <p className="leading-snug">{t("bannerCompact", { count: pending.length })}</p>
    </div>
  );
};

export default BessResignBanner;
